export default function ProductVariantsEditor({ variants = [], onChange }) {
  const updateVariant = (index, field, value) => {
    const next = variants.map((v, i) =>
      i === index ? { ...v, [field]: value } : v
    );
    onChange(next);
  };

  const updateAttribute = (index, attrIndex, field, value) => {
    const next = variants.map((v, i) => {
      if (i !== index) return v;
      const attrs = [...(v.attributes || [])];
      attrs[attrIndex] = { ...attrs[attrIndex], [field]: value };
      return { ...v, attributes: attrs };
    });
    onChange(next);
  };

  const addAttribute = (index) => {
    const next = variants.map((v, i) =>
      i === index
        ? {
            ...v,
            attributes: [...(v.attributes || []), { name: '', value: '' }],
          }
        : v
    );
    onChange(next);
  };

  const removeAttribute = (index, attrIndex) => {
    const next = variants.map((v, i) => {
      if (i !== index) return v;
      const attrs = (v.attributes || []).filter((_, j) => j !== attrIndex);
      return { ...v, attributes: attrs };
    });
    onChange(next);
  };

  const addVariant = () => {
    onChange([
      ...variants,
      {
        sku: '',
        label: '',
        price: '',
        originalPrice: '',
        stock: 0,
        images: [],
        attributes: [{ name: 'Size', value: '' }],
        inStock: true,
      },
    ]);
  };

  const removeVariant = (index) => {
    onChange(variants.filter((_, i) => i !== index));
  };

  return (
    <div className="form-group full">
      <div className="flex-between mb-2">
        <label>Product Variants</label>
        <button type="button" className="btn btn-sm btn-ghost" onClick={addVariant}>
          + Add Variant
        </button>
      </div>
      {variants.length === 0 ? (
        <p className="text-muted text-sm">
          No variants. Product uses base price and stock settings above.
        </p>
      ) : (
        <div className="variants-list">
          {variants.map((variant, index) => (
            <div key={variant._id || index} className="variant-card card nested">
              <div className="flex-between mb-2">
                <strong>Variant {index + 1}</strong>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => removeVariant(index)}
                >
                  Remove
                </button>
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>SKU *</label>
                  <input
                    className="input"
                    value={variant.sku || ''}
                    onChange={(e) => updateVariant(index, 'sku', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Label *</label>
                  <input
                    className="input"
                    value={variant.label || ''}
                    onChange={(e) => updateVariant(index, 'label', e.target.value)}
                    placeholder="e.g. Medium / 500g"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Price (₹) *</label>
                  <input
                    type="number"
                    className="input"
                    min="0"
                    value={variant.price ?? ''}
                    onChange={(e) =>
                      updateVariant(index, 'price', parseFloat(e.target.value) || 0)
                    }
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Original Price (₹)</label>
                  <input
                    type="number"
                    className="input"
                    min="0"
                    value={variant.originalPrice ?? ''}
                    onChange={(e) =>
                      updateVariant(
                        index,
                        'originalPrice',
                        e.target.value === '' ? '' : parseFloat(e.target.value)
                      )
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Stock</label>
                  <input
                    type="number"
                    className="input"
                    min="0"
                    value={variant.stock ?? 0}
                    onChange={(e) =>
                      updateVariant(index, 'stock', parseInt(e.target.value, 10) || 0)
                    }
                  />
                </div>
                <div className="form-group">
                  <label>Image URLs (comma separated)</label>
                  <input
                    className="input"
                    value={(variant.images || []).join(', ')}
                    onChange={(e) =>
                      updateVariant(
                        index,
                        'images',
                        e.target.value
                          .split(',')
                          .map((s) => s.trim())
                          .filter(Boolean)
                      )
                    }
                  />
                </div>
                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      checked={variant.inStock !== false}
                      onChange={(e) => updateVariant(index, 'inStock', e.target.checked)}
                    />
                    In Stock
                  </label>
                </div>
              </div>
              <div className="mt-2">
                <div className="flex-between mb-1">
                  <span className="text-sm">Attributes</span>
                  <button
                    type="button"
                    className="btn btn-sm btn-ghost"
                    onClick={() => addAttribute(index)}
                  >
                    + Attribute
                  </button>
                </div>
                {(variant.attributes || []).map((attr, attrIndex) => (
                  <div key={attrIndex} className="form-grid compact">
                    <input
                      className="input"
                      placeholder="Name (Size, Color...)"
                      value={attr.name || ''}
                      onChange={(e) =>
                        updateAttribute(index, attrIndex, 'name', e.target.value)
                      }
                    />
                    <input
                      className="input"
                      placeholder="Value"
                      value={attr.value || ''}
                      onChange={(e) =>
                        updateAttribute(index, attrIndex, 'value', e.target.value)
                      }
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-ghost"
                      onClick={() => removeAttribute(index, attrIndex)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
